import format from '@/utils/formatNumber'

export default (value, options) => format.number(value, options)
